<template>
    <div class="tag-group" >
        <el-tag class="tag"
                :class="{'active':active(tag.path)}"
                v-for="tag in visitedViews"
                :key="tag.title"
                :closable="tag.closable"
                type="info"
                @click.native="handleClickTag(tag)"
                @close="handleClickClose(tag)">
            {{tag.title}}
        </el-tag>
    </div>
</template>

<script>
    export default {
        name: "Tab",
        data() {
            return {

            };
        },
        computed: {
            visitedViews() {
                return this.$store.state.tagsView.visitedViews
            }
        },
        methods: {
            active(path){
                return this.$route.path == path;
            },
            handleClickTag(tag) {
                this.router.push({path: tag.path});
            },
            handleClickClose(tag){
                this.$store.dispatch('delView',tag);
                if (this.$store.state.tagsView.visitedViews.length==0){
                    return  this.router.push('/work')
                }
                this.router.push(this.$store.state.tagsView.visitedViews[this.$store.state.tagsView.visitedViews.length-1].path)
            }
        }
    }
</script>

<style scoped>
    .active{
        background: rgba(64,158,255,.1);
        color: #409eff;
        border-color: #409eff;
    }
    .tag-group {
        height: 38px;
        background: #fff;
        margin-left: 59px;
        padding: 6px 5px;
        border: 0.1px solid rgba(18, 106, 211, .125);
        overflow-x: scroll;
        overflow-y:hidden;
        display: -webkit-box;
        display: flex;
        -webkit-flex-wrap:nowrap;
        flex-wrap:nowrap;

    }
    .tag-group::-webkit-scrollbar {/*滚动条整体样式*/
        width: 2px;     /*高宽分别对应横竖滚动条的尺寸*/
        height: 2px;
    }
    .tag {
        border-radius: 0;
        margin: 0 2px;
    }
</style>
